'use client';

import React from 'react';
import { PortfolioImageCard } from '@ui';

export interface PortfolioTabProps {
  title: string;
  description?: string;
  locale?: 'en' | 'es';
  /** Slug of the parent portfolio section (e.g. `web`); used for item detail URLs. */
  sectionSlug?: string;
  portfolioImages?: Array<{
    id: string;
    title: string;
    /** Role / stack line (e.g. Frontend · Content). */
    meta?: string;
    description: string;
    description_long?: string;
    image_url: string;
    image_url_2x?: string;
    url?: string;
    target?: string;
    rel?: string;
    hasOverlay?: boolean;
    hasPageSlug?: boolean;
    pageSlug?: string;
    hidden?: boolean;
  }>;
}

const PortfolioTab: React.FC<PortfolioTabProps> = ({
  description,
  portfolioImages,
  sectionSlug,
  locale = 'en',
}) => {
  return (
    <div className='portfolio-container'>
      {description ?? null}
      {Array.isArray(portfolioImages) && portfolioImages.length > 0 ? (
        <div className='portfolio-container-grid'>
          {portfolioImages
            .filter((img) => img.hidden !== true)
            .map((img, idx) => (
              <PortfolioImageCard
                key={img.id}
                locale={locale}
                carousel-index={idx + 1}
                carousel-item={{
                  title: img.title,
                  label: img.description,
                  meta: img.meta,
                  image_url: img.image_url,
                  image_url_2x: img.image_url_2x,
                  url: img.url,
                  target: img.target,
                  rel: img.rel,
                  hasOverlay: img.hasOverlay,
                  description_long: img.description_long,
                  hasPageSlug: img.hasPageSlug,
                  pageSlug: img.pageSlug,
                  sectionSlug,
                }}
              />
            ))}
        </div>
      ) : null}
    </div>
  );
};

export default PortfolioTab;
